import React from 'react';
import Text from '../index';
import './index.css';
import MainStyles from '../../../styles/MainStyles';

const TextError = ({text, size, color}) => {
  return(
    <Text 
      ownClass={`title-light txt-error`}
      text={text}
      size={size ? size : 'little-more'}
      color={MainStyles.colors.white}
    />
  )
}

export default TextError;